import { ChevronRight } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  onClick: () => void;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <div className="flex items-center gap-2 mb-6 py-3 px-4 bg-white rounded-lg border border-content-border flex-wrap">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && <ChevronRight size={14} className="text-content-secondary" />}
          <button
            onClick={item.onClick}
            disabled={index === items.length - 1}
            className={`bg-transparent border-none py-1 px-2 rounded text-sm transition-colors duration-150 ${
              index === items.length - 1
                ? 'text-content-primary font-semibold cursor-default'
                : 'text-oak-green font-normal cursor-pointer hover:bg-oak-green/10'
            }`}
          >
            {item.label}
          </button>
        </span>
      ))}
    </div>
  );
}
